<template>
  <div class="controls">
    <h3>{{ $t('messages.sharedTexts.controls.controls') }}</h3>
    <div class="controls__layout">
      <div
        v-if="computedShowRainShutdown"
        class="controls__layout__rainshutdown-wrapper"
      >
        <rain-shut-down-control
          :rain-shut-down = "rainShutDown"
          :rain-shut-down-started = "rainShutDownStarted"
          :controller-group="controllerGroup"
          :controller-mode="controllerMode"
          :show-rain-shut-down-spinner = "store.getData('rainShutDown.showRainShutDownSpinner')"
          @SetPageMessage = "SetPageMessage"
        />
      </div>
      <div>
        <button
          class="g-btn g-btn--rounded"
          @click="surveyButtonClicked()"
        >
          <span><font-awesome-icon :icon="['custom', 'station']" /></span><span>{{ $t('messages.controlsElement.stationSurvey') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
/* ------ */
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import RainShutDownControl from '@/components/RainShutDownControl'

export default
{
  name: 'Controls',
  components:
  {
    'rain-shut-down-control': RainShutDownControl,
    'font-awesome-icon': FontAwesomeIcon
  }, // Available in this.$options.name
  mixins: [SocketHandler, LifeCycle],
  props: {
    controllerMode: {
      type: Number,
      default: null
    },
    controllerGroup: {
      type: String,
      default: null
    },
    rainShutDown: {
      type: Number,
      default: null
    },
    rainShutDownStarted: {
      type: Boolean,
      default: false
    },
    wheelState: {
      type: Boolean,
      default: false
    },
    showRainShutDownSpinner: {
      type: String,
      default: null
    },
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    computedShowRainShutdown() {
      return this.controllerGroup && this.controllerGroup !== 'TWC'
    }
  },
  watch: {
    PageMessage(Message) {
      if (Message.target === 'controls-survey-open-dialogue-modal-continue') {
        this.$route.path !== '/survey'
        ? this.$router.push('/survey')
        : this.SetPageMessage({
          target: 'Dashboard',
          message: 'close'
        })
      }
    }
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    surveyButtonClicked(Message) {
      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'DialogueModal',
          data: {
            title: 'Station Survey',
            text: 'Starting a Station Survey will stop all stations and programs.',
            prefix: 'controls-survey-open-dialogue-modal-',
            options: [
              {label: 'continue', value: 'continue'}
            ]
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.controls {
  &__layout {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    align-items: center;
    justify-content: space-around;

    > div {
      display: inline-block;
      display: flex;
      justify-content: center;
    }

    > *:last-child {
      text-align: center;

      .g-btn {
        box-sizing: border-box;
        display: inline-block;
        font-size: 14px;
        display: inline-grid;
        grid-template-columns: 30px 1fr;

        > * {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        > *:first-child {
          font-size: 20px;
        }
      }
    }
  }
}
// .controls {
//   &__layout {
//     display: flex;
//     align-items: center;

//     > *:last-child {
//       flex-grow: 1;
//       text-align: center;

//       .g-btn {
//         box-sizing: border-box;
//         display: inline-block;
//         font-size: 14px;
//         display: inline-grid;
//         grid-template-columns: 30px 1fr;

//         > * {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         > *:first-child {
//           font-size: 20px;
//         }
//       }
//     }
//   }
// }

/*@media screen and (min-width: $bp-tablet) {
  .controls {
    &__layout {
      > *:last-child {
        text-align: left;
        margin-left: 20px;
      }
    }
  }
}*/
</style>
